import { OptimizedOption } from '../../../../_types';
import { optimizedCriterion } from '../../../../searchCriteria';

import { QuickSearchFilter } from '@cast/shared-search-ui';

const labelMap: Record<OptimizedOption, string> = {
  optimized: 'Optimized',
  none: 'Not optimized',
};

const optionLabels = (option: OptimizedOption) => labelMap[option];

const optimizedOptions = Object.values(OptimizedOption).map((option) => ({
  title: optionLabels(option),
  value: option,
}));

export const OptimizedQuickSearch = () => {
  return (
    <QuickSearchFilter
      options={optimizedOptions}
      criterion={optimizedCriterion}
      multiple
    />
  );
};
